<script>
import ContactForm from '../../components/contactForm.vue';

export default {
    name: "qaa",
    data() {
        return {
            activeIndex: null,
            indexNum: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨'],
            list: [
                {
                    title: '艺术家的插画需要多少预算？',
                    text: '所有的艺术家都是按照具体的需求来报价，具体的需求可能需要考量下面这些因素',
                    type: 1,
                    list: [
                        {
                            title: '可交付成果是什么？',
                            text: [
                                '首先，你的品牌，没错，无论是国际知名品牌还是初创公司，我们都一视同仁，但如果您的品牌在行业里具有高知名度或者有非常好的声誉，艺术家会更乐意合作，并在价格方便提供便利。',
                                '第二，我们需要知道您需要多少幅插作品，以及这些作品的风格和复杂程度。您是否已经明确了主题，或者从艺术家的作品查看一些特别吸引您注意的例子会非常有用。您可以向我们提供一些复杂程度与您期待的相似的作品。通过这些信息，我们将能够计算出艺术家完成这项工作需要多长时间。如果您需要的是现有作品，可以直接到我们的图库中去选择，或者直接联系我们的商务，并告诉我们作品数量、可能的预算和指定的哪几幅作品。',
                            ]
                        },
                        {
                            title: '我们需要知道艺术家的作品将被您如何使用？',
                            text: [
                                '我们了解您希望艺术家创作什么之外，还需要讨论您将如何利用或使用他们，委托定制创作不意味着你完全拥有作品，艺术家将保留版权。您拥有的是一个许可使用权，该许可权利规定了您可以如何使用它以及在何处使用。因此，我们需要确定这些使用条款是什么。包括您会在哪些媒体上使用它们（在线、印刷、广告牌，线下商店等等）、还包括在世界的哪个国家/地区被看到和使用，它将被使用多长时间。一副作品使用得越多，它的成本就越高。另一方面，如果您对使用设置限制，成本就会下降。',
                                '我必须明确告诉您名单上艺术家我们是中国（含港澳台）的独家和战略合作代理，部分是亚洲地区和全球的独家代理，但如果你的授权国家包括中国但超出中国范围，例如你希望授权亚洲，请务必让我们知道，这涉及到艺术家在其他国家可能有其他的独家代理，或者在你希望授权的国家已经有排他的项目，我们会为您协商让您了解可行性。如果你希望授权地域不包括中国，则务必让我们与艺术家确认可行性，通常在中国的客户或在中国的品牌都是我们负责（我们也知道现在很多客户的产品是外贸或出海的，但不影响我们合作）',
                            ],
                        },
                        {
                            title: '如果你需要不受限制，自由的永远以任何方式、在任何地方使用，这有可能吗？',
                            text: [
                                '是的，我们经常协商并设置不受媒体限制，永久时效，甚至全球可使用，但艺术家仍保留版权。'
                            ]
                        },
                        {
                            title: '还会不会有其他的费用？',
                            text: [
                                '有时候，项目可能需要艺术家出行或购买特定材料，有些项目可能需要摄影师，摄制组，剪辑和修图后期人员等。有项目要求艺术家将合作的内容发布在他自己的社交媒体账号上并关联客户的账号，以及那些发布的内容可以被客户用于宣传的。我们会尽可能准确地考虑这些成本，并将其纳入我们的报价中。'
                            ]
                        },
                        {
                            title: '提供的价格还能有商量的余地么？',
                            text: [
                                '如果您提供了上述的具体需求信息，我们将很快提供您初步的报价，但依然可以被协商，最终费用将以完全签署协议为准。但通常我们提供的价格都很准确。'
                            ]
                        },
                    ]
                },
                {
                    title: '如果是委托定制创作的作品，艺术家的创作周期大概有多久？',
                    text: '从您订单确认并支付后，需要提供非常详细的创作需求，如果你是个新手，我们会提供一个模版，并引领您提供出明确细节的需求，艺术家收到创作需求后会提出一些问题来明确理解您的内容，之后他们就开始进入创作工作。艺术家创作的时间从2周到几个月不等，有鉴于项目的复杂程度，请至少提供足够的创作时间和前期沟通时间这样才能得到优秀且满足你需求的作品。如果你没有足够的时间，建议你能直接选择现有作品授权。'
                },
                {
                    title: '品牌可以授权现有的作品吗？',
                    text: '当然，但取决于该作品的相关授权许可协议，如果该作品是有效的（有些作品涉及到排它，所以我们需要事先明确您选择的作品是有效的），我们将很乐意与您沟通许可授权的费用。您也可以去我们的作品库中挑选。或者告诉我们你的需求，我们为您提供相关建议作品和艺术家。'
                },
                {
                    title: '作为客户能直接与艺术家沟通吗？',
                    text: '一般情况下我们不建议您直接联系艺术家，无论在文化和习惯上的差异，还是工作方式上的不同，我们都希望您的项目能顺利进行，而与艺术家良好的信任关系与沟通技巧很多时候能让项目进行的更加顺利，这也是我们存在的意义。但针对一些特殊的案子，例如艺术家与品牌的长期合约，这个时候可能需要更深入的了解品牌或者需要提供品牌更深入的服务的时候，艺术家的直接参与是有必要的，但我们会时刻密切关注并抄送电子邮件并进行视频通话等。如果需要，我们会随时帮助任何一方并让流程顺利进行。'
                },
                {
                    title: '如果在网站上找到艺术家，能不能直接联系他们？',
                    text: '我们的艺术家从幕后工作中受益匪浅。首先，我们投入了大量的时间和金钱来推广我们的机构和他们的作品。然后，当涉及到项目时，我们会处理谈判、合同（您知道每个国家的法律是不同的，当涉及国际的合约时，是需要有专业的人提供专业的服务）、报价和项目管理，这样让艺术家和客户都更轻松。但归根到底还是需要讲究礼仪。请始终先与我们联系。'
                },
                {
                    title: '如果之前从未委托过艺术家，您能帮助我们吗？',
                    text: '当然。我们与各行业和各种类型的客户合作，有些客户在与艺术家合作方面经验丰富，但有些客户则是第一次。如果您之前从未委托过艺术家，我们的团队将指导您完成整个过程。甚至帮助您整理一份简介（包括可能的翻译）以及委托创作的注意事项。'
                },
                {
                    title: '根据不同的需求，我们需要提交哪些信息请求？',
                    text: '除了了解艺术家和您想要授权的艺术作品名称之外，请务必收集尽可能多的有关您的项目信息。获得使用艺术家作品的许可是确保您的项目不仅符合法律标准，而且尊重相关艺术家的创作努力的关键步骤。无论您是在制作电影、书籍、广告活动还是任何其他创意作品，奢颜艺术都会指导您完成每一步。请记住，尊重版权不仅仅是一项法律义务，也是一种对道德创造力的承诺，可以增强您作品的完整性和影响力。',
                    type: 2,
                    list: [
                        {
                            title: '商品用途：',
                            text: [
                                '产品类型',
                                '零售/批发价',
                                '生产数量',
                                '分销——它将在哪里销售？',
                                '请求的许可期限',
                                '产品和包装的布局'
                            ]
                        },
                        {
                            title: '社交媒体用途：',
                            text: [
                                '每个平台/个人资料的关注者数量',
                                '标准广告或增强/赞助广告',
                                '图片及附带文字',
                            ]
                        },
                        {
                            title: '数字广告或网站展示：',
                            text: [
                                '网站网址',
                                '页面描述',
                                '广告类型（侧边栏、横幅、弹出）',
                                '如果用于广告则提供 PDF 的模版',
                            ]
                        },
                        {
                            title: '横幅、壁画和标志等展示用途：',
                            text: [
                                '位置',
                                '显示屏尺寸和材质',
                                '印刷件或屏幕数量（如果适用）',
                                'PDF 样例',
                            ]
                        },
                        {
                            title: '印刷用途，如书籍、电子书、目录或杂志：',
                            text: [
                                '出版物标题/描述',
                                '印刷数量或流通量',
                                '地域分布（中国或全球）',
                                '出版物将以以下语言印刷',
                                '复制件的尺寸（1/2 页、整页、¼ 页、双页等）',
                                '该图像是出现在封面、封底还是书籍封面上？',
                                '如果适用，该出版物的零售价是多少？',
                                '对于封面使用，PDF 模型',
                                '您的出版物是专著吗？换句话说，您的出版物中 40% 的内容是专门介绍某位艺术家的作品吗？',
                            ]
                        },
                        {
                            title: '电影、电视或视频用途：',
                            text: [
                                '剧情简介，包括演员和导演',
                                '为什么选择这位艺术家和这件特别的作品来演绎这个场景？',
                                '剧本中是否引用了艺术作品？或者“未引用”，只是背景布景？',
                                '您需要额外的促销权利吗？',
                                '这件艺术品将在屏幕上停留多长时间？',
                            ]
                        },
                        {
                            title: '演出、讲座或现场活动：',
                            text: [
                                '演出或活动的开始和结束日期',
                                '会场',
                                '席位数量',
                                '入场费或费用范围',
                                '艺术品将如何展出？',
                                '会展示多久？',
                                '是否会进行现场直播、录制或者在线播放？',
                            ]
                        },
                    ]
                },
                {
                    title: '其实我也是个艺术家，你们是否愿意代表我？',
                    text: '有可能，说实话，作为一家代理机构，需要更多专心在我们的范围内，我们的确有些忙不过来，因为希望对每个艺术家和客户都尽心尽力，你知道那需要花费很多时间和经历。但作为我们这样的代理机构总是有空间的。如果您认为您的作品与我们名单上的其他艺术家不同，并且确实能为我们的代理机构增添新意，请不要犹豫向我们提交作品。如果我们喜欢看到的作品，我们会与您联系。有时候部分艺术家的作品真让我们惊叹。'
                },
            ],
            history : window.history.length
        };
    },
    computed: {},
    components: {
        ContactForm
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        show(index) {
            if (this.activeIndex == index) { 
                this.activeIndex = null;
            } else {
                this.activeIndex = index;
                this.$nextTick(() => {
                    let offsetTop = this.$refs.qaa[index].offsetTop;
                    setTimeout(() => {
                        window.scrollTo({
                            top: offsetTop,
                            behavior: "smooth",
                        });
                    }, 300)
                })
            }
        }
    },
};
</script>

<template>
    <div class="qaa">
        <div class="layout_main wrapper">
            <div class="title">常见问题</div>
            <div class="list">
                <div class="item" ref="qaa" v-for="(item, index) in list" :key="index" :class="{active: activeIndex == index}">
                    <div class="question flex justify_between align_center">
                        <p>{{ item.title }}</p>
                        <div class="icon" @click="show(index)"></div>
                    </div>
                    <div class="answer">
                        <p class="text" v-html="$textToHtml(item.text)"></p>
                        <div class="list" :class="`type${item.type}`" v-if="item.list && item.list.length > 0">
                            <div class="item" v-for="(_item, _index) in item.list" :key="_index">
                                <p class="title">
                                    <span v-if="item.type == 1">{{ indexNum[_index] }} </span>
                                    {{ _item.title }}
                                </p>
                                <div class="text">
                                    <p v-for="(__item, __index) in _item.text" :key="__index">
                                        <span v-if="item.type == 2">{{ indexNum[__index] }} </span>
                                        {{ __item }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify_end" v-if="history > 2"><div class="btn" @click="$router.go(-1)">返回</div></div>
            <div class="flex justify_end" v-else><router-link class="btn" to="/talents">返回</router-link></div>
        </div>
        <ContactForm from="人才"/>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    padding: .5rem 0;
    >.title{
        font-size: .3rem;
        @media only screen and (max-width: 750px) {
            font-size: .36rem;
            font-weight: bold;
        }
    }
    .btn{
        font-size: .18rem;
        margin-top: .2rem;
        cursor: pointer;
        @media only screen and (max-width: 750px) {
            display: none;
        }
    }
    >.list{
        letter-spacing: .04em;
        >.item{
            border-bottom: 1px solid #666;
            padding: .2rem 0;
            margin-bottom: .35rem;
            @media only screen and (max-width: 750px) {
                margin-bottom: 0;
                padding: .45rem 0;
                border-bottom-color: #ccc;
            }
            &:last-child{
                margin-bottom: 0;
            }
            &.active{
                .question{
                    .icon{
                        &::after{
                            display: none;
                        }
                    }
                }
                .answer{
                    display: block;
                }
            }
            .question{
                font-size: .22rem;
                @media only screen and (max-width: 750px) {
                    font-size: .32rem;
                }
                .icon{
                    flex-shrink: 0;
                    margin-left: .2rem;
                    width: .4rem;
                    height: .4rem;
                    border: 1px solid #666;
                    border-radius: 50%;
                    position: relative;
                    cursor: pointer;
                    &::before,
                    &::after{
                        content: "";
                        display: block;
                        width: 60%;
                        border-bottom: 1px solid #666;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                    &::after{
                        transform: translate(-50%, -50%) rotate(90deg);
                    }
                }
            }
            .answer{
                display: none;
                font-size: .2rem;
                padding: .3rem 0;
                @media only screen and (max-width: 750px) {
                    font-size: .3rem;
                }
                .list{
                    padding: .5rem 0 0 .4rem;
                    @media only screen and (max-width: 750px) {
                        padding-left: 0;
                    }
                    .item{
                        margin-bottom: .5rem;
                        &:last-child{
                            margin-bottom: 0;
                        }
                        .title{
                            margin-bottom: .2rem;
                        }
                        .text{
                            @media only screen and (max-width: 750px) {
                                font-weight: 100;
                                color: #666;
                            }
                        }
                    }
                    &.type1{
                        .item{
                            .title{
                                font-weight: bold;
                                @media only screen and (max-width: 750px) {
                                    font-weight: normal;
                                }
                            }
                            .text p{
                                margin-bottom: .2rem;
                            }
                        }
                    }
                    &.type2{
                        .item{
                            display: flex;
                            .title{
                                white-space: nowrap;
                            }
                            .text{
                                display: flex;
                                flex-wrap: wrap;
                                gap: .04rem;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>